import { Megaphone } from "lucide-react";

const NEWS = [
  { name: "Depozit", text: "Minimum depozit cəmi 15 ₼" },
  { name: "Promokod", text: "Promokodla bonus qazan" },
  { name: "Yeni oyunlar", text: "Rulet, Plinko, Dice, Hi-Lo və daha çoxu" },
  { name: "Çıxarış", text: "m10 və karta sürətli çıxarış, min. 25 ₼" },
  { name: "Demo", text: "Demo rejimdə pulsuz oynayıb məşq et" },
  { name: "Dəstək", text: "Texniki dəstək 24/7 xidmətinizdədir" },
];

export const WinTicker = () => {
  const doubled = [...NEWS, ...NEWS, ...NEWS];
  return (
    <div className="border-y border-white/10 bg-[#0c0c0c] overflow-hidden py-3" data-testid="news-ticker">
      <div className="marquee-track gap-12">
        {doubled.map((w, i) => (
          <div key={i} className="flex items-center gap-2 text-sm whitespace-nowrap px-6">
            <Megaphone size={14} className="text-[#D4AF37]" />
            <span className="text-white font-semibold">{w.name}</span>
            <span className="text-zinc-400">{w.text}</span>
          </div>
        ))}
      </div>
    </div>
  );
};
